var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5928 19.6916C25.7561 19.6916 23.9527 19.4043 22.2437 18.8395C21.4062 18.5539 20.3768 18.8159 19.8657 19.3409L16.4925 21.8873C12.5805 19.7991 10.1709 17.3902 8.11117 13.5076L10.5827 10.2223C11.2248 9.58102 11.4551 8.6443 11.1791 7.76539C10.612 6.04742 10.3238 4.24484 10.3238 2.40734C10.3239 1.07992 9.24398 0 7.91664 0H2.40727C1.07992 0 0 1.07992 0 2.40727C0 17.6221 12.378 30 27.5928 30C28.9202 30 30.0001 28.9201 30.0001 27.5927V22.0988C30 20.7715 28.9201 19.6916 27.5928 19.6916Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.2d10eb4319f863925ac7c25bba8c87bb.svg";
export { ForwardRef as ReactComponent };